import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '*',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./menu/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'asistencia',
    loadChildren: () => import('./menu/asistencia/asistencia.module').then( m => m.AsistenciaPageModule)
  },
  {
    path: 'empleados',
    loadChildren: () => import('./menu/empleados/empleados.module').then( m => m.EmpleadosPageModule)
  },
  {
    path: 'permisos',
    loadChildren: () => import('./menu/permisos/permisos.module').then( m => m.PermisosPageModule)
  },
  {
    path: 'registro',
    loadChildren: () => import('./menu/registro/registro.module').then( m => m.RegistroPageModule)
  },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
